/**
 * Skeleton do Financeiro — header padrão + abas (médicos / clínica) +
 * card verde de ganho do mês + cards de caixa + tabela de lançamentos.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-7xl animate-pulse flex-col gap-6">
      {/* PageHeader */}
      <div className="h-[104px] rounded-[20px] bg-slate-200" />

      {/* Abas de médico / clínica */}
      <div className="h-11 w-72 rounded-xl border border-slate-200 bg-white" />

      {/* Ganho total do mês + fechamento de caixa */}
      <div className="grid gap-4 lg:grid-cols-4">
        <div className="h-32 rounded-[20px] bg-slate-200" />
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="h-32 rounded-xl border border-slate-200 bg-white p-4">
            <div className="h-3 w-20 rounded bg-slate-200" />
            <div className="mt-3 h-6 w-28 rounded bg-slate-200" />
          </div>
        ))}
      </div>

      {/* Tabela de lançamentos */}
      <div className="rounded-xl border border-slate-200 bg-white p-4">
        <div className="h-9 w-full max-w-lg rounded-lg bg-slate-100" />
        <div className="mt-4 flex flex-col gap-2">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="h-12 rounded-lg bg-slate-100" />
          ))}
        </div>
      </div>
    </div>
  );
}
